// Keep unfinished controls explicit until their real member-facing workflows
// are available. These notices must not imply a successful server operation.
export const comingSoonFeatures = {
  groups: {
    accessibleLabel: 'Groups — coming soon',
    notice: 'Fan groups are not available yet.',
  },
  media: {
    accessibleLabel: 'Media uploads — coming soon',
    notice: 'Photo and video post uploads are not available yet.',
  },
} as const

export const profileIdentitySetupNotice = 'Choose how other fans will know you. Display names and handles cannot currently be changed, so pick ones you’ll want to keep.'
